import React from 'react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { cn } from '../../../lib/utils';
import { Search, UserPlus } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../components/ui/dialog';
export const BajaAdminDialog = ({ cambiarPropietarioForm, cn, handleSaveCambiarPropietario, isCambiarPropietarioOpen, propietarioSearch, propietarios, saving, selectedUnidad, setCambiarPropietarioForm, setIsCambiarPropietarioOpen, setPropietarioSearch }) => {
  return (
      <Dialog open={isCambiarPropietarioOpen} onOpenChange={setIsCambiarPropietarioOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <UserPlus className="w-5 h-5 text-blue-600" />
              Cambiar Propietario - {selectedUnidad?.nombre_unidad}
            </DialogTitle>
          </DialogHeader>
          <form onSubmit={handleSaveCambiarPropietario}>
            <div className="space-y-4 py-4">
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm">
                <p className="text-amber-800">
                  <strong>Nota:</strong> El propietario actual ({selectedUnidad?.propietario_nombre}) será guardado en el historial de la unidad.
                </p>
              </div>

              {/* Buscador de propietarios */}
              <div className="space-y-2">
                <Label>Nuevo Propietario *</Label>
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400" />
                  <Input
                    placeholder="Buscar por nombre..."
                    value={propietarioSearch}
                    onChange={(e) => setPropietarioSearch(e.target.value)}
                    className="pl-10"
                  />
                </div>
                <div className="border rounded-lg max-h-40 overflow-y-auto">
                  {propietarios
                    .filter(p => 
                      p.propietario_id !== selectedUnidad?.propietario_id &&
                      p.nombre_razon_social.toLowerCase().includes(propietarioSearch.toLowerCase())
                    )
                    .sort((a, b) => a.nombre_razon_social.localeCompare(b.nombre_razon_social))
                    .map(p => (
                      <div
                        key={p.propietario_id}
                        className={cn(
                          "px-3 py-2 cursor-pointer hover:bg-slate-50 text-sm",
                          cambiarPropietarioForm.propietario_id === p.propietario_id && "bg-blue-50 text-blue-700 font-medium"
                        )}
                        onClick={() => setCambiarPropietarioForm({...cambiarPropietarioForm, propietario_id: p.propietario_id})}
                      >
                        {p.nombre_razon_social}
                      </div>
                    ))}
                </div>
              </div>

              {/* Fecha de adquisición */}
              <div className="space-y-2">
                <Label>Fecha de Adquisición</Label>
                <Input
                  type="date"
                  value={cambiarPropietarioForm.fecha_adquisicion}
                  onChange={(e) => setCambiarPropietarioForm({...cambiarPropietarioForm, fecha_adquisicion: e.target.value})}
                />
              </div>

              {/* Monto de inversión */}
              <div className="space-y-2">
                <Label>Monto de Inversión</Label>
                <div className="flex gap-2">
                  <Input
                    type="number"
                    placeholder="Monto"
                    value={cambiarPropietarioForm.monto_inversion?.monto || ''}
                    onChange={(e) => setCambiarPropietarioForm({
                      ...cambiarPropietarioForm,
                      monto_inversion: {...cambiarPropietarioForm.monto_inversion, monto: e.target.value}
                    })}
                    className="flex-1"
                  />
                  <Select
                    value={cambiarPropietarioForm.monto_inversion?.moneda || 'USD'}
                    onValueChange={(v) => setCambiarPropietarioForm({
                      ...cambiarPropietarioForm,
                      monto_inversion: {...cambiarPropietarioForm.monto_inversion, moneda: v}
                    })}
                  >
                    <SelectTrigger className="w-24">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="USD">USD</SelectItem>
                      <SelectItem value="ARS">ARS</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              </div>
            </div>
            <DialogFooter>
              <Button type="button" variant="outline" onClick={() => setIsCambiarPropietarioOpen(false)}>
                Cancelar
              </Button>
              <Button type="submit" disabled={saving || !cambiarPropietarioForm.propietario_id}>
                {saving ? 'Guardando...' : 'Cambiar Propietario'}
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
  );
};
